var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7523_6013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 34,
    r: 30,
    fill: "url(#paint0_linear_7523_6013)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7523_6013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5118 33.8563C24.5113 35.8728 25.0382 37.8417 26.04 39.5771L24.416 45.5066L30.4841 43.9156C32.1625 44.8292 34.0429 45.308 35.9539 45.3081H35.9589C42.2673 45.3081 47.4024 40.1748 47.4051 33.8653C47.4063 30.8079 46.2168 27.9329 44.0555 25.77C41.8945 23.6072 39.0206 22.4155 35.9584 22.4141C29.6493 22.4141 24.5145 27.5471 24.5119 33.8563",
    fill: "url(#paint1_linear_7523_6013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1034 33.8527C24.1028 35.9417 24.6486 37.981 25.6861 39.7786L24.0039 45.9207L30.2896 44.2726C32.0215 45.2168 33.9714 45.7147 35.9556 45.7154H35.9607C42.4954 45.7154 47.8151 40.3975 47.8179 33.8621C47.819 30.6949 46.5866 27.7166 44.3481 25.4761C42.1093 23.2359 39.1326 22.0013 35.9607 22C29.4249 22 24.106 27.3172 24.1034 33.8527ZM27.8467 39.469L27.612 39.0965C26.6254 37.5277 26.1047 35.7149 26.1054 33.8534C26.1075 28.4213 30.5284 24.0019 35.9645 24.0019C38.597 24.003 41.0711 25.0292 42.9319 26.8912C44.7927 28.7533 45.8166 31.2287 45.8159 33.8614C45.8135 39.2935 41.3926 43.7135 35.9607 43.7135H35.9568C34.1882 43.7126 32.4536 43.2376 30.9408 42.34L30.5808 42.1265L26.8508 43.1045L27.8467 39.4689V39.469Z",
    fill: "url(#paint2_linear_7523_6013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9969 28.8977C32.775 28.4044 32.5414 28.3945 32.3303 28.3858C32.1575 28.3784 31.9599 28.3789 31.7625 28.3789C31.5649 28.3789 31.2439 28.4532 30.9726 28.7495C30.7009 29.0461 29.9355 29.7627 29.9355 31.2203C29.9355 32.678 30.9972 34.0866 31.1452 34.2845C31.2934 34.482 33.1948 37.5689 36.2062 38.7564C38.7088 39.7433 39.2182 39.547 39.7613 39.4975C40.3046 39.4482 41.5142 38.7811 41.761 38.0892C42.008 37.3975 42.008 36.8046 41.934 36.6807C41.8599 36.5572 41.6623 36.4831 41.3661 36.335C41.0697 36.1868 39.6131 35.4701 39.3416 35.3712C39.07 35.2724 38.8725 35.2231 38.6749 35.5198C38.4773 35.8159 37.91 36.4831 37.737 36.6807C37.5643 36.8787 37.3914 36.9034 37.0952 36.7552C36.7987 36.6065 35.8446 36.2941 34.7126 35.2849C33.8318 34.4996 33.2372 33.5298 33.0644 33.2331C32.8915 32.937 33.0459 32.7764 33.1944 32.6288C33.3275 32.496 33.4908 32.2828 33.6391 32.1099C33.7868 31.9369 33.8361 31.8134 33.9349 31.6158C34.0338 31.4181 33.9843 31.2451 33.9103 31.0969C33.8361 30.9487 33.2604 29.4835 32.9969 28.8977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7523_6013",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.470588 0 0 0 0 0.470588 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7523_6013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7523_6013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7523_6013",
    x1: 36,
    y1: 4,
    x2: 36,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00860B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7523_6013",
    x1: 1173.87,
    y1: 2331.67,
    x2: 1173.87,
    y2: 22.4141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7523_6013",
    x1: 1214.7,
    y1: 2414.07,
    x2: 1214.7,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7523_6013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.82,
    height: 24,
    fill: "white",
    transform: "translate(24 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.236edda6578c49e004d5e05c8870e8ff.svg";
export { ForwardRef as ReactComponent };